//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: ['resident'],
	data: function data() {
		return {
			money: {
				decimal: '.',
				thousands: ',',
				prefix: '$',
				suffix: '',
				precision: 2,
				masked: false
			},
			loadingEditor: false,
			editLeases: false,
			residentLeases: []
		};
	},
	created: function created() {
		this.leaseInformation();
	},
	beforeDestroy: function beforeDestroy() {},

	methods: {
		leaseInformation: function leaseInformation() {
			var $el = this;
			$el.residentLeases = $el.resident.leases;
			// NOTE: this duplicates code from ResidentDetailsDashboard.vue so maybe a cleanup is in order
			if ($el.residentLeases.length) {
				var residentLeases = $el.residentLeases;
				for (var i = 0; i < residentLeases.length; i++) {
					if (residentLeases[i].lease_start_date) {
						$el.residentLeases[i].lease_start_date = $el.dateFilter(residentLeases[i].lease_start_date);
					}
				}
			}
		},
		dateFilter: function dateFilter(value) {
			if (moment(value).isValid()) return moment(value).format('MM/DD/YYYY');
		},
		saveLeaseData: function saveLeaseData() {
			var _this = this;

			var $el = this;
			var residentData = $el.resident;
			axios.post('/prototype/person/resident/lease-data', residentData).then(function (response) {
				if (response.data.error) {
					_this.$snotify.error('Error saving Lease data: ' + response.data.error);
				} else {
					_this.$snotify.success('Lease data was updated');
					_this.editLeases = false;
					Event.$emit('refresh-resident-dashboard');
				}
			});
		},
		editLeaseData: function editLeaseData() {
			this.editLeases = true;
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/LeaseInformation.vue
// module id = qynQ
// module chunks = 0 1